<template>
  <div class="stepper-component">
    <v-navigation-drawer
      right
      mini-variant-width="80"
      app
      :width="asideWidth"
      height="100vh"
      class="navigation"
      :class="{ disabled: currentStep === 0 }"
    >
      <v-loader
        v-if="isLoading"
        absolute
      />

      <div
        v-if="showOrderApplyError"
        class="person-error d-flex align-center justify-center"
      >
        <div
          class="error-window d-flex flex-column align-center justify-center"
        >
          <span class="error-window-title">Внимание</span>
          <span
            v-if="basket.persons === 0"
            class="error-window-text"
          >Вы не указали количество персон</span>
          <v-btn
            class="error-window-button"
            x-large
            dark
            depressed
            @click="showOrderApplyError = false"
          >
            Ок
          </v-btn>
        </div>
      </div>

      <div class="stepper-content d-flex flex-column justify-space-between">
        <div class="stepper-header">
          <step-indicator
            :step="currentStep"
            :is-tabs-blocked="isTabsBlocked"
            :available-steps="availableSteps"
            @change-step="changeStepByTab"
          />
          <div class="button-group-section d-flex align-center j-between">
            <span class="label font-weight-medium">Ваш заказ:</span>
            <div class="buttons d-flex align-center">
              <v-btn-toggle
                v-model="otherWindow"
                dense
                group
              >
                <v-btn
                  value="modifications"
                  class="button-param button-toggle font-weight-medium"
                  depressed
                  color="#F1F3F6"
                >
                  М
                </v-btn>
                <v-btn
                  value="commentaries"
                  class="button-param button-toggle font-weight-medium"
                  depressed
                  color="#F1F3F6"
                >
                  <font-awesome-icon icon="comment-dots" />
                </v-btn>
                <v-btn
                  value="preorder"
                  class="button-param button-toggle font-weight-medium"
                  :class="{'v-item--active': hasPreorder}"
                  :disabled="!basket.filialId"
                  depressed
                  color="#F1F3F6"
                >
                  <font-awesome-icon icon="clock" />
                </v-btn>
              </v-btn-toggle>
            </div>
          </div>
        </div>

        <div class="order-list-section">
          <div
            v-if="!normalBasketItems && !modBasketItems"
            class="empty-section d-flex align-center justify-center flex-column"
          >
            <font-awesome-icon
              icon="shopping-bag"
              color="#DDE1E6"
            />
            <span>Не добавлено...</span>
          </div>
          <perfect-scrollbar :options="{ suppressScrollX: true }">
            <div class="order-list-content">
              <div
                v-if="normalBasketItems || modBasketItems"
                class="food-counter"
              >
                <food-counter
                  v-for="item in normalBasketItems"
                  :key="item.hash"
                  :item="item"
                />
                <food-counter
                  v-for="modItem in modBasketItems"
                  :key="modItem.id"
                  :item="modItem"
                />
                <food-counter
                  v-for="commentItem in commentBasketItems"
                  :key="commentItem.id"
                  :item="commentItem"
                />
              </div>
            </div>
          </perfect-scrollbar>
        </div>

        <div class="stepper-footer">
          <v-delivery
            v-if="showDelivery"
            :price="basket.deliveryPrice"
          />
          <div class="order-info-section">
            <v-row class="order-details">
              <v-col>
                <person-count />
              </v-col>
              <v-col>
                <div class="payment-method">
                  <span class="label">Тип оплаты</span>
                  <span class="method-title font-weight-bold">{{
                    getPaymentType
                  }}</span>
                </div>
                <promocode-short :promocode="basket.promoCode" />
              </v-col>
              <v-col>
                <div class="payment-amount">
                  <span class="label">Итого к оплате</span>
                  <span class="amount font-weight-medium">{{ getTotalPrice | amountWithCurrency }}</span>
                  <span
                    v-if="basket.discountTotal"
                    class="d-block"
                  >Скидка: {{ basket.discountTotal | amountWithCurrency }}</span>
                </div>
                <fox-coin-label />
              </v-col>
            </v-row>

            <!--            <div v-if="isNewClient" style="font-weight: bold; margin-bottom: 10px; margin-top: -5px; font-size: 13px; color: red">
              <font-awesome-icon icon="exclamation-circle" style="margin-right: 5px; font-size: 16px"/> НОВЫЙ КЛИЕНТ
            </div>-->

            <client-source-select
              v-show="currentStep !== 2"
              action="new-order"
            />

            <additional-actions v-if="currentStep === 2" />

            <v-card
              v-if="showMinSummCard"
              border-color="#ff0034"
              outlined
              class="min-summ-card mb-3 pa-3 mx-1"
            >
              <span class="display-1 font-weight-medium">Минимальная сумма заказа {{ basket.minOrderPrice | amountStringWithCurrency }}</span>
            </v-card>

            <v-filials v-if="currentStep >= 2" />

            <delivery-pickup />

            <delivery-address
              v-if="basket.clientAddress"
              :address="basket.clientAddress"
            />

            <div class="submit-section">
              <v-btn
                v-if="currentStep === 1"
                class="button-submit font-weight-medium"
                width="100%"
                color="#FB8C00"
                dark
                depressed
                :disabled="isDeliveryNotSet"
                @click="setSecondStep"
              >
                Перейти к составу заказа
              </v-btn>

              <v-btn
                v-if="currentStep === 2"
                class="button-submit font-weight-medium"
                width="100%"
                color="#FB8C00"
                dark
                depressed
                :disabled="!basketItems.length"
                @click="setThirdStep"
              >
                Перейти к оплате
              </v-btn>

              <div
                v-if="currentStep === 3"
                class="combined-submit-button d-flex a-center"
              >
                <transition
                  name="fadeUp"
                  :duration="100"
                >
                  <cooking-time
                    v-if="showClocksWindow"
                    @close="showClocksWindow = false"
                  />
                </transition>
                <v-btn
                  :disabled="isApplyOrderDisabled"
                  class="button-clocks"
                  color="#FB8C00"
                  dark
                  depressed
                  @click="showClocksWindow = !showClocksWindow"
                >
                  <icon-clocks />
                </v-btn>
                <v-btn
                  class="button-submit apply-order font-weight-medium"
                  width="100%"
                  color="#FB8C00"
                  dark
                  depressed
                  :disabled="isApplyOrderDisabled"
                  @click="applyOrder"
                >
                  Оформить
                  <template v-if="isPreorder">
                    предзаказ
                  </template>
                  <br>
                  <template v-if="isPreorder">
                    (Начать готовить за {{ getCookingAndDeliveryTime }})
                  </template>

                  <template v-else>
                    {{ getCookingAndDeliveryTime }}
                  </template>
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-navigation-drawer>
    <!-- Сумма ниже минимальной: подтверждение перехода к оплате (по праву) -->
    <primary-confirm-dialog
      v-model="showMinSumConfirm"
      :persistent="false"
      confirm-text="Продолжить"
      cancel-text="Вернуться назад"
      @confirm="confirmMinSum"
    >
      <template v-slot:title>
        <div class="min-sum-confirm-title">
          <v-icon class="min-sum-confirm-title__icon" color="#ff0034" size="40">
            mdi-alert
          </v-icon>
          <span>Сумма заказа меньше минимальной</span>
        </div>
      </template>
      <template v-slot:subtitle>
        Вы действительно хотите оформить такой заказ?
      </template>
    </primary-confirm-dialog>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import VLoader from '@/components/loader/Loader'
  import IconClocks from '@/components/icons/IconClocks.vue'
  import FoodCounter from '../../order-components/stepper/FoodCounter.vue'
  import DrinkDetails from './DrinkDetails'
  import DeliveryAddress from '@/components/order-processing/order-components/stepper/DeliveryAddress'
  import DeliveryPickup from '@/components/order-processing/order-components/stepper/DeliveryPickup'
  import PersonCount from '@/components/order-processing/order-components/stepper/PersonCount'
  // import VPromocode from '@/components/order-processing/order-components/stepper/Promocode'
  import VDelivery from '@/components/order-processing/order-components/stepper/Delivery'
  import CookingTime from '@/components/order-processing/order-components/stepper/CookingTime'
  import VFilials from '@/components/order-processing/order-components/stepper/Filials'
  import mixinGetCookingTime from '@/mixins/get-cooking-time'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'
  // import FoxCoinAddLabel from '@/components/order-processing/order-components/stepper/FoxCoinAddLabel'
  import PaymentType from '@/models/enums/PaymentType'
  import FoxCoinLabel from '@/components/order-processing/order-components/stepper/FoxCoinLabel'
  import ClientSourceSelect from '@/components/order-processing/order-components/stepper/ClientSourceSelect'
  import _ from 'lodash'
  import StepIndicator from '@/components/order-processing/order-components/stepper/StepIndicator'
  import AdditionalActions from '@/components/order-processing/new-order/stepper/AdditionalActions.vue'
  import PrimaryConfirmDialog from '@/components/ui/dialogs/PrimaryConfirmDialog.vue'
  import permissions from '@/mixins/permissions'
  import CRMPermission from '@/models/enums/permissions/CRMPermission'

  export default {
    name: 'Stepper',
    components: {
      AdditionalActions,
      PrimaryConfirmDialog,
      StepIndicator,
      ClientSourceSelect,
      FoxCoinLabel,
      // FoxCoinAddLabel,
      VLoader,
      FoodCounter,
      VDelivery,
      DrinkDetails,
      DeliveryAddress,
      DeliveryPickup,
      PersonCount,
      // VPromocode,
      CookingTime,
      IconClocks,
      VFilials,
    },
    mixins: [mixinGetCookingTime, mixinSnackbarMessage, permissions],
    data () {
      return {
        asideWidth: 454,
        showOrderApplyError: false,
        showMinSumConfirm: false,
        isTabsBlocked: true,
        showClocksWindow: false,
      }
    },
    watch: {
      isBasketHaveDrinks () {
        if (this.isBasketHaveDrinks) {
          this.$store.commit('newOrder/setDrinkDetailsStatus', true)
        }
      },
    },
    computed: {
      ...mapState({
        isDrinksSuggested: state => state.newOrder.isDrinksSuggested,
        currentOtherWindow: state => state.newOrder.currentOtherWindow,
        basket: state => state.baskets.basket,
        isLoading: state => state.baskets.isBasketLoading,
        currentStep: state => state.newOrder.currentStep,
        paymentMode: state => state.newOrder.paymentMode,
        availableSteps: state => state.newOrder.availableSteps,
        categories: state => state.categories.categoriesList,
        isBasketLoading: state => state.baskets.isBasketLoading,
      }),
      ...mapGetters({
        normalBasketItems: 'baskets/getNormalBasketItems',
        modBasketItems: 'baskets/getModifiedBasketItems',
        commentBasketItems: 'baskets/getCommentedBasketItems',
        basketItems: 'baskets/getItems',
        getTotalPrice: 'baskets/getTotalPrice',
        isSourceAggregator: 'baskets/isSourceAggregator',
      }),
      isNewClient () {
        return this.basket.client && !this.basket.client.firstCompletedOrderId
      },
      hasPreorder () {
        return !!this.basket.dateDelivery
      },
      isDeliveryNotSet () {
        return !this.basket?.deliveryType
      },
      isApplyOrderDisabled () {
        return !this.basketItems.length || !this.basket.filialId || !this.basket.paymentType || (!this.basket.clientAddress && !this.basket.deliveryType) || this.needSetClientSource || this.isBasketLoading
      },
      needSetClientSource () {
        return false
        // return this.isNewClient && !this.hasClientRegistrationSource && !this.isSourceAggregator
      },
      hasClientRegistrationSource () {
        return !!this.basket?.client?.registrationMarketingSource
      },
      isPreorder () {
        return !!this.basket.toDatetime
      },
      allowSetDeliveryTime () {
        return !!this.basket.deliveryType
      },
      isBasketHaveDrinks () {
        /* const basketItems = this.basket.items || null
        const drinksCategory = this.categories.find(category => category.slug === 'drinks')
        if (basketItems && drinksCategory) {
          const drinksMenuItems = drinksCategory.menuItems.map(item => item.id)
          return !!basketItems.some(item => {
            return drinksMenuItems.includes(item.menuItemId)
          })
        } */
        return false
      },
      showMinSummCard () {
        // На шаге оплаты сотрудник с правом уже подтвердил заказ ниже минимума - карточка не нужна
        if (this.currentStep === 3 && this.userCan(CRMPermission.CreateOrderBelowMinSum)) {
          return false
        }
        return this.isBelowMinSum
      },
      /** Сумма ниже минимума и у сотрудника есть право оформить такой заказ */
      needMinSumConfirm () {
        return this.userCan(CRMPermission.CreateOrderBelowMinSum) && this.isBelowMinSum
      },
      /** Минимум считает бэкенд (бонусы, промокод 100%, настройка филиала) - здесь только флаг корзины */
      isBelowMinSum () {
        return Boolean(this.basket.isBelowMinOrderPrice)
      },
      otherWindow: {
        get () {
          return this.currentOtherWindow
        },
        set (value) {
          this.$store.commit('newOrder/setCurrentOtherWindow', value)
        },
      },
      showDelivery () {
        return (
          this.basket.deliveryPrice && this.basket.deliveryPrice.amount !== '0'
        )
      },
      getPaymentType () {
        if (this.basket.paymentType) {
          return PaymentType.getName(this.basket.paymentType, this.basket.deliveryType, this.paymentMode)
        }
        return '–'
      },
      allowOrderCreation: function () {
        if (this.basket.deliveryType === 'delivery' && !this.basket.clientAddress) {
          return false
        }

        if (this.basketItems.length && this.basket.paymentType &&
          this.basket.deliveryType) {
          return true
        }

        return false
      },
    },
    mounted () {
      this.$nextTick(() => {
        this.calcAsideWidth()
      })
      if (this.isBasketHaveDrinks) {
        this.$store.commit('newOrder/setDrinkDetailsStatus', true)
      }
    },
    created () {
      window.addEventListener('resize', this.calcAsideWidthOnResize)
    },
    destroyed () {
      window.removeEventListener('resize', this.calcAsideWidthOnResize)
    },
    methods: {
      changeStepByTab (i) {
        // if (!this.isTabsBlocked) {
        this.$store.commit('newOrder/setStep', i)
        // }
      },
      async applyOrder () {
        if (this.basket.persons === 0) {
          this.showOrderApplyError = true
          return
        }
        this.$store.commit('baskets/setBasketLoading', true)

        try {
          const response = await this.$store.dispatch('orders/createOrders', {
            basketId: this.basket.id,
            paymentMode: this.paymentMode,
          })

          if (response.status === 200) {
            await this.handleSuccessfulCreation(response.data.data.id)
          } else {
            this.showErrorMessage(response.response.data.message)
          }
        } catch (e) {
          this.showErrorFromResponse(e)
        } finally {
          this.$store.commit('baskets/setBasketLoading', false)
        }
      },
      async handleSuccessfulCreation (orderId) {
        // Обнвовляем корзину
        this.$store.dispatch('baskets/fetchSingleBasket', this.basket.id)

        // Заказ оформлен - плашка свёрнутого заказа больше не нужна
        this.$store.commit('collapsedOrders/remove', this.basket.id)

        try {
          // Получаем информацию по созданному заказу и открываем результирующее окно
          const response = await this.$store.dispatch('orders/fetchSingleOrders', orderId)

          if (response.status === 200) {
            this.$store.commit('orders/setCurrentOrderInfo', response.data.data)
            this.$store.commit('newOrder/setSecondStepWindow', 'payment')
            this.$store.commit('newOrder/setCurrentPaymentTab', 'paid')
          }
        } catch (e) {
          this.showErrorFromResponse(e)
        } finally {
          this.showSuccessMessage('Заказ успешно создан')
          this.resetOrderData()
          this.$store.commit('app/setAllowPageExitWithoutConfirm', true)
          this.$store.commit('baskets/setBasketLoading', false)
          this.$router.push('/orders')
        }
      },
      resetOrderData () {
        this.$store.commit('newOrder/setStep', 0)
        this.$store.commit('newOrder/togglePromotionsWindow', false)
        this.$store.commit('newOrder/toggleCommentKeyboard', false)
        this.$store.commit('newOrder/setCurrentOtherWindow', undefined)
        this.$store.commit('newOrder/setSecondStepWindow', 'address')
        this.$store.commit('newOrder/setCurrentPaymentTab', 'paymentTypes')
        this.$store.commit('baskets/setBasket', {})
      },
      setSecondStep () {
        this.$store.commit('newOrder/setStep', 2)
      },
      setThirdStep () {
        if (this.basket.persons === 0) {
          this.showOrderApplyError = true
          return
        }
        if (this.needMinSumConfirm) {
          this.showMinSumConfirm = true
          return
        }
        this.goToThirdStep()
      },
      goToThirdStep () {
        this.isTabsBlocked = false
        this.$store.commit('newOrder/setStep', 3)
      },
      confirmMinSum () {
        this.showMinSumConfirm = false
        this.goToThirdStep()
      },
      setStep (i) {
        this.$store.commit('newOrder/setStep', i)
      },
      calcAsideWidth () {
        this.asideWidth = window.innerWidth < 1900 ? 355 : 454
      },
      calcAsideWidthOnResize: _.debounce(function () {
        this.calcAsideWidth()
      }, 100),
    },
  }
</script>

<style lang="less" scoped>
.stepper-component {
  font-size: 12px;

  .media-xl({
    font-size: 14px;
  });

  .person-error {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(33, 33, 33, 0.46);
    z-index: 1;

    .error-window {
      width: 95%;
      padding: 3.35em 15px 1.85em 15px;
      border-radius: 10px;
      background: #fff;
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);

      .error-window-title {
        display: inline-block;
        margin-bottom: 3px;
        font-size: 1.78em;
        line-height: 25px;
      }

      .error-window-text {
        display: inline-block;
        margin-bottom: 2.42em;
        font-size: 1em;
        line-height: 1;
      }

      .error-window-button {
        background-color: @color-primary;
      }
    }
  }

  .button-param {
    font-size: 1.78em;
    line-height: 1;
    width: 2em;
    height: 2em;
    min-width: 2em !important;
    padding: 0 !important;
  }

  .navigation {
    padding-top: 15px;
    background-color: transparent;

    .media-xl({
      padding-top: 23px;
    });

    .media-compact-pc({
      padding-top: 8px;
    });

    &:after {
      content: '';
      position: absolute;
      display: none;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(#fafafa, 0.8);
    }

    &.disabled:after {
      display: block;
    }

    ::v-deep {
      .v-navigation-drawer__border {
        width: 0;
      }
    }
  }

  .tabs-section {
    margin-bottom: 20px;
    border-bottom: 1px solid #d4d4d4;

    .tab {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.71em;
      line-height: 1.3;
      font-weight: bold;
      background-color: transparent;
      flex: 1;
      height: 2.65em;
      border-radius: 5px 5px 0 0;
      outline: none;
      cursor: default;

      &.unblocked {
        cursor: pointer;
      }

      &.active {
        background-color: @color-primary;
        color: #ffffff;
      }
    }
  }

  .button-group-section {
    // Компактный десктоп: кнопки окон заказа стоят в левом сайдбаре (aside/Menu.vue),
    // заголовок «Ваш заказ:» убран - высота отдана списку позиций.
    // !important - у .d-flex от Vuetify display с !important
    .media-compact-pc({
      display: none !important;
    });

    .label {
      font-size: 2.3em;
      line-height: 1;
    }

    .button-param {
      margin-right: 15px;
    }

    ::v-deep {
      .button-toggle {
        border-radius: 10px !important;
        background-color: #f1f3f6 !important;

        &.v-item--active {
          background-color: @color-primary !important;
          color: #ffffff;

          svg {
            .fill-svg(#ffffff);
          }
        }

        &:before {
          display: none;
        }
      }
    }
  }

  .stepper-content {
    height: 100%;
    padding-left: 10px;
  }

  .order-list-section {
    min-height: 200px;
    height: 100%;
    flex: 1;
    border-bottom: 1px solid #d4d4d4;
    margin-bottom: 17px;
    display: flex;
    flex-direction: column;
    align-items: center;

    // компактный десктоп: меньше отступ от линии до блока «Кол-во персон»
    // (под линией ещё 12px поля колонки)
    .media-compact-pc({
      margin-bottom: 4px;
    });

    .order-list-content {
      position: relative;
      overflow-y: auto;
      z-index: 0;

      .food-counter {
        margin-top: 1.43em;

        // компактный десктоп: отступ над первой позицией вдвое меньше
        .media-compact-pc({
          margin-top: 0.71em;
        });
      }
    }

    .empty-section {
      width: 100%;
      height: 100%;

      span {
        color: #dde1e6;
        font-size: 2.43em;
        line-height: 30px;
        user-select: none;
      }

      svg {
        width: 64px;
        height: 73px;
        margin-bottom: 23px;
      }
    }
  }

  .order-info-section {
    margin-bottom: 27px;

    // компактный десктоп: под кнопкой оформления 5px - высота отдана списку позиций
    .media-compact-pc({
      margin-bottom: 5px;
    });

    .label {
      font-size: 1em;
      line-height: 1.5;
      display: block;
      margin-bottom: 6px;
    }

    .order-details {
      margin-bottom: 5px;
      flex-wrap: nowrap;

      .payment-method {
        text-align: center;

        .method-title {
          font-size: 1em;
          line-height: 1.1;
          word-break: break-word;
          margin-top: -3px;
          display: block;
          margin-bottom: 3px;
          .media-xl({
            font-size: 1.14em;
            line-height: 1.125;
          });
        }
      }

      .payment-amount {
        .amount {
          white-space: nowrap;
          font-size: 2.14em; //30px;
          line-height: 1.2;
          margin-top: -7px;
          display: block;
        }
      }

      .person-count {
        .count {
          display: block;
          font-size: 1.78em;
          line-height: 1;
          margin: 0 12px;
        }
      }
    }

    .submit-section {
      .combined-submit-button {
        position: relative;
        z-index: 1;
      }

      .button-clocks {
        height: 5.71em !important;
        font-size: 1.07em;
        border-radius: 10px 0 0 10px;
        position: relative;
        z-index: 1;

        &:after {
          content: '';
          position: absolute;
          right: 0;
          top: 0;
          bottom: 0;
          margin: auto;
          width: 1px;
          height: 54px;
          background-color: rgba(0, 0, 0, 0.1);
        }
      }

      .button-submit {
        height: 5.71em !important;
        font-size: 1.07em;
        line-height: 1.4;
        flex: 1;
        border-radius: 10px;

        &.apply-order {
          border-radius: 0 10px 10px 0;
        }
      }
      .v-btn--disabled {
        color: rgba(#000000, 0.3) !important;
        background-color: rgb(241, 243, 246) !important;
      }
    }
  }

  .min-summ-card {
    border-color: @color-error;
    color: @color-error;
  }

  ::v-deep {
    .ps {
      width: 100%;
    }
  }
}

.min-sum-confirm-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;

  &__icon {
    animation: min-sum-pulse 1.2s ease-in-out 2;
  }
}

@keyframes min-sum-pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.12); }
}
</style>
